import { Box } from '@mui/material';
import React from 'react';
import { FootNoteProps } from '../../models/TopLevelTemplateComponentProps';
import sanitizeHTML from '../../services/sanitizeHTML';
import LinkifiedHtml from '../LinkifiedHtml';
import { Palette } from 'Palette';
import { FONT_INTER, StyledTypography } from '../styles/styles';
import { ListItem } from './leftRightListUtils';

interface LeftRightListItemRowProps {
  item: ListItem;
  index: number;
  tone: keyof typeof Palette;
  paletteBorder: string;
  footnotes?: FootNoteProps[] | null;
}

export default function LeftRightListItemRow({
  item,
  index,
  tone,
  paletteBorder,
  footnotes,
}: LeftRightListItemRowProps) {
  const itemPalette = Palette[tone];
  const textArray = Array.isArray(item.text) ? item.text : [item.text];
  return (
    <Box
      className="list-border"
      sx={{
        display: 'flex',
        flexDirection: ['column', 'row'],
        backgroundColor: itemPalette.background,
        alignItems: 'center',
        color: itemPalette.text,
        borderTop: index > 0 ? `1px solid ${paletteBorder}` : undefined,
      }}
    >
      <Box sx={{ width: ['100%', '30%'], p: 2, fontWeight: 600 }}>
        <StyledTypography fontWeight={600}>{item.heading.content}</StyledTypography>
      </Box>
      <Box
        sx={{
          width: ['100%', '70%'],
          p: 2,
          '& .MuiBox-root:first-child > .MuiBox-root:first-of-type p': { mt: 0 },
          '& .MuiBox-root:last-child > .MuiBox-root:last-of-type p': { mb: 0 },
        }}
      >
        {textArray.map(
          (text) =>
            text && (
              <Box key={text.id} sx={{ mb: 1 }}>
                <LinkifiedHtml
                  as={Box}
                  sx={{ fontFamily: FONT_INTER, fontSize: '1rem' }}
                  html={sanitizeHTML(text.content, { footnotes })}
                />
              </Box>
            ),
        )}
      </Box>
    </Box>
  );
}
